module.exports = __webpack_public_path__ + "img/page60.5991ea6f.gif";